import { Component, Output, EventEmitter, Inject, OnInit, ViewChild, ViewContainerRef, ChangeDetectorRef, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { LegendService } from '../legend.service'
import { take } from 'rxjs/operators';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { BackEventService } from '@tt-lib/services/back-event.service';

@Component
  ({
    selector: 'tt-legend-dialog',
    imports: [
      MatIconModule,
      MatButtonModule,
      TranslateModule,
      MatDialogModule
    ],
    templateUrl: './legend-dialog.component.html',
    styleUrls: ['./legend-dialog.component.css'],
    standalone: true
  })
export class LegendDialogComponent implements OnInit {

  activeLayerLabel: string;
  activeLayerId: string;
  legendItem;
  data = inject<any>(MAT_DIALOG_DATA)

  constructor(
    // private cfr: ComponentFactoryResolver,
    private cdr: ChangeDetectorRef,
    public legendService: LegendService,
    public dialogRef: MatDialogRef<LegendDialogComponent>,
    //@Inject(MAT_DIALOG_DATA) public data: any
    private backEventService: BackEventService
  ) { }

  @ViewChild('legendDialogContainer', { read: ViewContainerRef }) legendDialogContainer: ViewContainerRef;

  ngOnInit(): void {
    this.activeLayerLabel = this.data.activeLayerLabel;
    this.activeLayerId = this.data.activeLayerId;
    this.legendItem = this.data.legendItem;

    this.dialogRef.beforeClosed().pipe(take(1)).subscribe(() => {
      this.legendDialogContainer.clear();
      this.legendDialogContainer.remove();
      // this.legendItem.legendComponentRef.instance.active = false;

    });

    this.backEventService.registerOpenedWindow({windowName: 'LegendDialogComponent', isAutoCloseableWindow: true});

    setTimeout(() => {
      // this.loadComponent();
    }, 0)
  }

  ngAfterViewInit() {
    // setTimeout(() => {
    this.loadComponent();
    this.cdr.detectChanges(); //prevent the ExpressionChangedAfterItHasBeenCheckedError
    // }, 0)
  }

  loadComponent() {
    // const legendFactory = this.cfr.resolveComponentFactory(this.legendItem);
    // this.legendItem.legendComponentRef = <Component>this.legendDialogContainer.createComponent(legendFactory);//, null, this.injector
    this.legendItem.legendComponentRef = <Component>this.legendDialogContainer.createComponent(this.legendItem);//, null, this.injector
    this.legendItem.legendComponentRef.instance.active = true;
  }
  ngOnDestroy() {
    if (this.legendItem.legendComponentRef) {
      this.legendItem.legendComponentRef.destroy();
    }
  }
}
